module.exports = __webpack_public_path__ + "images/map/map-europe-5252c880e75122ceb199e3b11120c464.png";